import { defineStore } from "pinia";
import { userAccountStore } from "./loginStore";
import { PostRequest } from "@/network";


export const cartStore = defineStore('cartstore', {
    id: 'cartstore',
    state: () => ({
        headerData: {
            cart: [],
            saveForLater: [],
            productCounts: {}
        },
        shippingData: {
            method: '',
            data: []
        },
        Payments: {
            method: '',
            data: {},
            amount: 0,
            promoCode: ''
        }
    }),
    actions: {
        manageProductsQuantity(id, quantity) {
            if (this.headerData.productCounts[id] == undefined) {
                this.headerData.productCounts[id] = quantity;
                return this.headerData.productCounts[id];
            } else {
                return this.headerData.productCounts[id];
            }
        },
        AddToCart(itemId) {
            if (this.headerData.saveForLater.includes(itemId)) {
                this.RemoveToSaveForLater(itemId);
            }

            this.headerData.cart.push(itemId);
            this.SyncCart();
        },
        RemoveToCart(itemId) {
            const index = this.headerData.cart.indexOf(itemId);
            if (index !== -1) {
                this.headerData.cart.splice(index, 1);
            }

            if (this.headerData.productCounts[itemId]) {
                delete this.headerData.productCounts[itemId]
            }

            this.SyncCart();
        },
        AddToSaveForLater(itemId) {
            if (this.headerData.cart.includes(itemId)) {
                this.RemoveToCart(itemId);
            }
            this.headerData.saveForLater.push(itemId);
            this.SyncCart();
        },
        RemoveToSaveForLater(itemId) {
            const index = this.headerData.saveForLater.indexOf(itemId);
            if (index !== -1) {
                this.headerData.saveForLater.splice(index, 1);
            }
            this.SyncCart();
        },
        ListCart() {
            return this.headerData.cart;
        },
        ListSaveLater() {
            return this.headerData.saveForLater;
        },
        async loadCart() {
            console.log("Cart Loaded!")
            const users = userAccountStore();
            // var cartList = {
            //     cart: [],
            //     saveLater: []
            // }
            if (users.userLoginValidate() == true) {
                const data = {
                    "auth": {
                        "id": users.userProfile.id,
                        "email": users.userProfile.email,
                        "username": users.userProfile.username,
                        "name": `${users.userProfile?.firstName} ${users.userProfile?.lastName}`,
                        "key": users.userToken
                    }
                }
                const request = await PostRequest(`/cart/CartList/list`, data, '', 'user');
                console.log("cart store request loading : ", request );
                // if (request?.status == 200) {
                //     this.headerData.cart = JSON.parse(request.data.cart);
                //     this.headerData.saveForLater = JSON.parse(request.data.saveLate);
                //     cartList.cart = this.headerData.cart;
                //     cartList.saveLater = this.headerData.saveForLater;
                //     console.log("if ". cartList)
                //     return cartList;
                // } else {
                //     cartList.cart = this.headerData.cart;
                //     cartList.saveLater = this.headerData.saveForLater;
                //     console.log("else ". cartList)
                //     return cartList;
                // }
            }
        },
        async SyncCart() {
            console.log("Cart synked!")
            const users = userAccountStore();
            if (users.userLoginValidate() == true) {
                const data = {
                    "auth": {
                        "id": users.userProfile.id,
                        "email": users.userProfile.email,
                        "username": users.userProfile.username,
                        "name": `${users.userProfile?.firstName} ${users.userProfile?.lastName}`,
                        "key": users.userToken
                    },
                    "cart": JSON.stringify(this.headerData.cart),
                    "saveLater": JSON.stringify(this.headerData.saveForLater)
                }
                const request = await PostRequest(`/cart/CartList/update`, data, '', 'user');
                if (request?.status != 200) {
                    this.cart = JSON.parse(request.data.cart);
                    this.saveForLater = JSON.parse(request.data.saveLate);
                }
            }
        }
    },
    persist: {
        key: 'electosh-cart-data',
        storage: localStorage
    }
})